require('./taxAndRentsView.scss');

const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');

// @actions
const taxAndRentsActions = require('actions/taxAndRents');
const documentActions = require('actions/documents');
import additionalDocumentActions from 'actions/additionalDocumentation';

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TaxAndRents = require('components/taxAndRents/taxAndRents/taxAndRents');
const FiscalInformationLinks = require('components/taxAndRents/fiscalInformationLinks/fiscalInformationLinks');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const WebappRender = require('components/conditionalRender/webappRender')

// @helpers
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');

// @constants
import { FISCAL_INFORMATION, FISCAL_INFORMATION_GROUP } from 'constants/index';
const { GRAPHIC_TUTOR_TYPE_2 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class TaxAndRentsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideBlocks: false //This state is used to hide some blocks.Dont make it true without buisness confirmation
        }
        this.onAccountNumberChange = this.onAccountNumberChange.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.callbackDownloadFiscalFile = this.callbackDownloadFiscalFile.bind(this);
    }

    componentDidMount() {

        const { immDocuments } = this.props;

        this.props.setGroupSelected(FISCAL_INFORMATION_GROUP);

        if (!Boolean(immDocuments.get('documentsByGroup').get(FISCAL_INFORMATION_GROUP))) {
            this.props.requestMoreDocuments(true);
        }

        this.handleRequestDocuments();
    }

    handleRequestDocuments() {
        this.props.requestAdditionalDocumentation(FISCAL_INFORMATION);
    }

    buildHeader() {
        const linkToPaymentWithDraft = '/myprofile/taxAndRents/payment-with-draft';
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_2}
                title={formatText('tutorials-profileTaxAndRentsTitle')}
            />
        );

        return (
            <OKHeaderLanding
                title={formatText("breadcrumb-taxAndRents")}
                tutorial={tutorial}>
                {this.state.hideBlocks && <div className="tax-and-rents__payment-with-draft">
                    <OKButton
                        modifier="primary"
                        to={linkToPaymentWithDraft}
                    >
                        <FormattedText value="taxAndRents-paymentWithDraft" />
                    </OKButton>
                </div>}
            </OKHeaderLanding>
        );
    }

    onAccountNumberChange(accountId) {
        const { immAccounts, getTaxesAndRents, setAccountNumber } = this.props;

        const account = immAccounts.get('byId').get(accountId);
        const iban = account.getIn(['ibanComplex', 'codbban']);
        const controlDigit = getControlDigitFromCodBban(iban)
        const accountNumber = account.get('product') + account.get('contractNumber');

        setAccountNumber(accountNumber, controlDigit, accountId);
        getTaxesAndRents(accountId);
    }

    callbackDownloadFile(file) {
        this.props.requestDocumentsPdf({
            filename: file.filename,
            gestorDocumental: file.gestorDocumental,
            codigoSubaplicacion: file.codSubaplicacion,
            codComunicacion: file.codComunicacion
        });
    }


    callbackDownloadFiscalFile(params, filename) {
        this.props.getFileSaddeDocuments(params, filename)
    }

    render() {
        const { taxAndRents, immAccounts, immFlagBasedFeatures, postGetDetails, immDocuments, additionalDocuments, requestMoreDocuments } = this.props;
        const header = this.buildHeader();

        if (!taxAndRents.get(['isFetching'])) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="small" section="pg" customClass="col-xs-12">
                                {header}
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-positive">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TaxAndRents
                                                immAccounts={immAccounts}
                                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                                handleAccountChange={this.onAccountNumberChange}
                                                taxAndRents={taxAndRents}
                                                postGetDetails={postGetDetails}
                                                immDocuments={immDocuments}
                                                additionalDocuments={additionalDocuments}
                                                requestDocuments={requestMoreDocuments}
                                                callbackDownloadFile={this.callbackDownloadFile}
                                                callbackDownloadFiscalFile={this.callbackDownloadFiscalFile}
                                                showAutoDates={false}
                                                hideBlocks={this.state.hideBlocks}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        {this.state.hideBlocks && <div className="col-xs-12 col-md-12 grid-view--variable-cell-separation">
                                            <FiscalInformationLinks />
                                        </div>}
                                        <div className="col-xs-6 col-md-12">
                                            <CallMeBack pageTitle={formatText("breadcrumb-taxAndRents")} hasEntrance={false} />
                                        </div>
                                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                            <WebappRender>
                                                <CommercialAds path="taxAndRents" type="banner-a" />
                                            </WebappRender>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (<LoadingSection />);
        }
    }
}

TaxAndRentsView.propTypes = {
    getTaxesAndRents: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immDocuments: PropTypes.object.isRequired,
    additionalDocuments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    requestDocumentsPdf: PropTypes.func.isRequired,
    getFileSaddeDocuments: PropTypes.func.isRequired,
    requestMoreDocuments: PropTypes.func.isRequired,
    requestAdditionalDocumentation: PropTypes.func.isRequired,
    setAccountNumber: PropTypes.func.isRequired,
    setGroupSelected: PropTypes.func.isRequired,
    postGetDetails: PropTypes.func.isRequired,
    taxAndRents: PropTypes.object.isRequired,
};

module.exports.constructor = TaxAndRentsView;

module.exports.TaxAndRentsView = connect(state => ({
    immAccounts: state.accounts,
    immDocuments: state.documents,
    additionalDocuments: state.additionalDocumentation,
    immFlagBasedFeatures: state.flagBasedFeatures,
    taxAndRents: state.taxAndRents,
}), {
    getTaxesAndRents: taxAndRentsActions.getTaxesAndRents,
    setAccountNumber: taxAndRentsActions.setAccountNumber,
    postGetDetails: taxAndRentsActions.postGetDetails,
    requestMoreDocuments: documentActions.requestMoreDocuments,
    getFileSaddeDocuments: additionalDocumentActions.getFileSaddeDocuments,
    requestAdditionalDocumentation: additionalDocumentActions.requestAdditionalDocumentation,
    setGroupSelected: documentActions.setGroupSelected,
    requestDocumentsPdf: documentActions.requestDocumentsPdf
})(TaxAndRentsView);
